import type {ArrayFields} from '../../../features/mypage/context/ReportEditContext';
import type {DegreeType} from '../university/constants';

export const ProfileLabels = {
  GENERAL: '基本情報',
  PR_MESSAGE: '自己PR・ひとことPR',
  WISH: '志望',
  MENTALITY: '志向・性格',
  EDUCATION: '学歴',
  INTERN: 'インターンシップ経験',
  ADDITIONAL_BACKGROUND: 'その他経歴',
  LANGUAGE: '言語スキル',
  IT_SKILL: '開発・プログラミング経験',
  FOREIGN_EXPERIENCE: '海外在住経験',
  OFFER: '就活状況・内定先',
};

export const WishTypes = {
  TYPES: {
    LOCATION: 'location',
    JOB: 'job_type',
    INDUSTRY: 'industry',
    COMPANY: 'company',
  },
};

export const MentalityLengthLimit = {
  MIN: 1,
  MAX: 5,
} as const;

export const PlaceholderForDevelopmentExperience =
  'Web系の自社サービスを運営する企業でエンジニアとして1年半アルバイトを行っていました。主にサーバーサイドのGoでのAPI開発を担当。フロントエンドはReactとTypeScriptで構成されAWSのECS上で動いています。規模としては合計200程度のAPIがあります。最初の数ヶ月は社員の方にフォローしていただきながら開発しましたが、以降は1人で基本的な開発は行えるようになりました。ここでの大きな経験・成果としては、チーム開発を経験できたことと自分からサービスの改善案を提案しリリースまで至ったことです。GitHubを使用したチーム開発やコードレビューによって基本的な開発のやり方を学べたのと、コードの読みやすさやアーキテクチャも意識できるようになりました。またユーザーに記事をレコメンドするロジックの改善案を出し実際にリリース、クリック率を124%にすることに成功しました。';

export const PlaceholderForDevelopmentService = 'IDを入力してください';

export const PlaceholderForDevelopmentHashtags = ['Python', 'C++', '機械学習'];

export const DevelopmentExperienceBodyLength = 1000; // 開発経験概要のTextfieldの最大文字数
export const DevelopmentExperienceFormLength = 10; // 開発経験のフォームの最大数
export const DevelopmentServiceIdLength = 50; // 外部登録サービスIDの最大文字数

export const ES_POST_LIMIT = 20; // エントリーシートの最大投稿件数（下書きを除く）

export const DegreeTypes = {
  ASSOCIATE: {
    LABEL: '高等専門学校(準学士)',
    TYPE: 'associate' as DegreeType,
  },
  BACHELOR: {
    LABEL: '大学(学士)',
    TYPE: 'bachelor' as DegreeType,
  },
  GRADUATE: {
    LABEL: '大学(修士)',
    TYPE: 'graduate' as DegreeType,
  },
  DOCTOR: {
    LABEL: '大学(博士)',
    TYPE: 'doctor' as DegreeType,
  },
};

export const EnglishSkillMaxPoints = {
  TOEIC: 990,
  TOEFL_IBT: 120,
  TOEFL_ITP: 677,
} as const;

export const SelectionType = [
  {
    value: 'selection',
    label: '本選考',
  },
  {
    value: 'spring',
    label: '春インターン',
  },
  {
    value: 'summer',
    label: '夏インターン',
  },
  {
    value: 'autumn',
    label: '秋インターン',
  },
  {
    value: 'winter',
    label: '冬インターン',
  },
];

export const ReportStepType = [
  {
    value: '1',
    label: '説明会',
    prefix: 'conference',
  },
  {
    value: '2',
    label: 'エントリーシート',
    prefix: 'es',
  },
  {
    value: '3',
    label: '筆記試験・WEBテスト・適性検査',
    prefix: 'paperExam',
  },
  {
    value: '4',
    label: 'グループディスカッション',
    prefix: 'gd',
  },
  {
    value: '5',
    label: 'その他の選考（ジョブ・インターンなど）',
    prefix: 'other',
  },
  {
    value: '6',
    label: '1次面接',
    prefix: 'interview',
  },
];
export const OfferStatusJoin = '1';

export const ReportStep = {
  CONFERENCE: '1',
  ES: '2',
  PAPER: '3',
  GD: '4',
  OTHER: '5',
  INTERVIEW: '6',
} as const;

// ReportStep.idに対応するフォームのフィールド
export const ReportStepFields: Record<string, ArrayFields[]> = {
  [ReportStep.CONFERENCE]: [
    'conferencePeriod',
    'conferenceTime',
    'conferenceContent',
    'conferenceImpression',
  ],
  [ReportStep.ES]: ['esQuestion', 'esPoint', 'esContact'],
  [ReportStep.PAPER]: ['paperExamForm', 'paperExamMeasure', 'paperExamContact'],
  [ReportStep.GD]: [
    'gdTheme',
    'gdTime',
    'gdNumber',
    'gdProceeding',
    'gdContact',
  ],
  [ReportStep.OTHER]: [
    'otherSchedule',
    'otherHowlong',
    'otherContent',
    'otherCollege',
    'otherReward',
    'otherImression',
    'otherContact',
  ],
  [ReportStep.INTERVIEW]: [
    'interviewWorker',
    'interviewStudent',
    'interviewPlace',
    'interviewTime',
    'interviewProceeding',
    'interviewQuestion',
    'interviewAtmosphere',
    'interviewImpression',
    'interviewContact',
  ],
};
